module.exports = __webpack_public_path__ + "img/qilin-stage6-blink.d5551d14.png";